import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../utilities/context";
import { useIntl } from "react-intl";
import axios from "axios";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import Container from "@mui/material/Container";
import Layout from "./Layout";
import Grid from "@mui/material/Grid";
import { Button, Box, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";

const Tags = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  const [tags, setTags] = useState([]);
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 });
  const [totalRows, setTotalRows] = useState(0);
  const [sortModel, setSortModel] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingTag, setEditingTag] = useState(null);
  const [formData, setFormData] = useState({ name: "" });

  const getTags = () => {
    const { page, pageSize } = paginationModel;
    let sortParams = "";
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0];
      sortParams = `&sortField=${field}&sortOrder=${sort}`;
    }
    axios.get(`/api/tags?page=${page}&pageSize=${pageSize}${sortParams}`)
      .then(res => {
        setTags(res.data.tags);
        setTotalRows(res.data.total);
      })
      .catch(err => console.error(err));
  };

  useEffect(() => {
    getTags();
    if (context) {
      context.updateBreadcrumbsState([
        { label: "Home", url: "/" },
        { label: "Tags" },
      ]);
    }
  }, [paginationModel, sortModel]);

  const handleOpenCreate = () => {
    setEditingTag(null);
    setFormData({ name: "" });
    setModalOpen(true);
  };

  const handleOpenEdit = (id) => {
    const tag = tags.find(t => t.id === id);
    if (tag) {
      setEditingTag(tag);
      setFormData({ name: tag.name });
      setModalOpen(true);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Eliminar este tag?")) {
      try {
        await axios.delete(`/api/tags/${id}`);
        getTags();
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleSave = async () => {
    try {
      if (editingTag) {
        await axios.put(`/api/tags/${editingTag.id}`, formData);
      } else {
        await axios.post("/api/tags", formData);
      }
      setModalOpen(false);
      getTags();
    } catch (err) {
      console.error(err);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "name", headerName: "Nombre", flex: 1 },
    { field: "slug", headerName: "Slug", width: 150 },
    {
      field: "actions",
      type: "actions",
      headerName: "Acciones",
      width: 100,
      getActions: ({ id }) => [
        <GridActionsCellItem icon={<EditIcon />} label="Edit" onClick={() => handleOpenEdit(id)} color="inherit" />,
        <GridActionsCellItem icon={<DeleteIcon />} label="Delete" onClick={() => handleDelete(id)} color="inherit" />,
      ],
    },
  ];

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={1}></Grid>
          <Grid item xs={12} sm={10} sx={{ textAlign: "right" }}>
            <Button variant="contained" size="small" onClick={handleOpenCreate} sx={{ mr: 1 }}>
              Crear
            </Button>
          </Grid>
          <Grid item xs={12} sm={1}></Grid>
          <Grid item xs={12} sm={1}></Grid>
          <Grid item xs={12} sm={10} sx={{ textAlign: "center" }}>
            <Box sx={{ height: 400, width: "100%" }}>
              <DataGrid
                rows={tags}
                columns={columns}
                pagination
                paginationMode="server"
                sortingMode="server"
                rowCount={+totalRows}
                pageSizeOptions={[5, 10, 25, 50]}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                sortModel={sortModel}
                onSortModelChange={(model) => setSortModel(model)}
                disableRowSelectionOnClick
                getRowId={(row) => row.id}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={1}></Grid>
        </Grid>
      </Container>

      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editingTag ? "Editar Tag" : "Nuevo Tag"}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <TextField
              label="Nombre"
              value={formData.name}
              onChange={(e) => setFormData({ name: e.target.value })}
              fullWidth
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)}>Cancelar</Button>
          <Button onClick={handleSave} variant="contained">Guardar</Button>
        </DialogActions>
      </Dialog>
    </Layout>
  );
};

export default Tags;
